import { store } from '../../../redux';
import { openNotificationPopIn } from '../../../redux/actions';
import { localStorageFuncs } from '../../helpers/';
import { AlertTypeEnum, NotificationData } from '../types';

export const stainReminderHandler = (e: MessageEvent) => {
  const notification = JSON.parse(e.data) as NotificationData;
  localStorageFuncs.set('lastSyncTimeStamp', new Date().getTime());
  const title = 'Alerte souillure';
  const subTitle = `Les trains suivants sont souillés :`;
  const confirmTxt = 'OK';
  store.dispatch(
    openNotificationPopIn(
      title,
      subTitle,
      notification.data as string[],
      confirmTxt,
      AlertTypeEnum.StainReminder,
    ),
  );
};

export default stainReminderHandler;
